import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { createRemoteVideoMenuButtonEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { IconVideoOff } from '../../../base/icons/svg';
import ContextMenuItem from '../../../base/ui/components/web/ContextMenuItem';
import { NOTIFY_CLICK_MODE } from '../../../toolbox/types';
import { sendCommand } from '../../../mod-command/slice';
import { COMMANDS } from '../../../mod-command/constants';
/**
 * Implements a React {@link Component} which displays a button for disabling
 * the camera of a participant in the conference.
 *
 * @returns {JSX.Element|null}
 */
const MuteVideoButton = ({ notifyClick, notifyMode, participantID, noIcon }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const tracks = useSelector((state) => state['features/base/tracks']);
    const handleClick = useCallback(() => {
        notifyClick?.();
        if (notifyMode === NOTIFY_CLICK_MODE.PREVENT_AND_NOTIFY) {
            return;
        }
        sendAnalytics(createRemoteVideoMenuButtonEvent('video.mute.button', {
            'participant_id': participantID
        }));
        // dispatch(openDialog(MuteRemoteParticipantsVideoDialog, { participantID }));
        dispatch(sendCommand(COMMANDS.MUTE_VIDEO_PARTICIPANT.COMMAND, participantID, true));
    }, [dispatch, notifyClick, notifyClick, participantID, sendAnalytics]);
    return (React.createElement(ContextMenuItem, { accessibilityLabel: t('participantsPane.actions.stopVideo'), className: 'mutevideolink', icon: noIcon ? null : IconVideoOff, onClick: handleClick, text: t('participantsPane.actions.stopVideo') }));
};
export default MuteVideoButton;
